// faceBridge — module-mutable channel (like talkBridge/beatBridge) carrying
// LIVE webcam face capture into the 3D character each frame, no React re-render.
//
// `yaw/pitch/roll` (radians) = head pose, applied to the character's Head bone —
// this is what visibly drives Rebel today. `blend` = the MediaPipe FaceLandmarker
// ARKit-52 blendshape coefficients (jawOpen, mouthSmile, browInnerUp, …), captured
// and exposed NOW but with nothing to bind to on the current rig (0 morph targets).
// The moment a face-rigged mesh lands, route `blend` → its morph targets and the
// performer's expression/mouth goes live too. See project_char_lipsync_performance.
export const faceBridge = { active: false, yaw: 0, pitch: 0, roll: 0, blend: {} };
